<template>
  <styled-wrapper
    :data-version="currentVersion"
    :data-fair-id="fairId"
    :data-service-group="currentServiceGroup"
    :data-regi-nr="currentRegiNr"
  >
    <styled-container :max-width="containerWidth">
      <styled-flex-wrapper>
        <!-- Logo -->
        <styled-logo-wrapper>
          <img
            src="data:image/svg+xml;base64,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"
            alt="BERNEXPO"
          />
        </styled-logo-wrapper>
        <styled-text-wrapper>
          <!-- fair title -->
          <styled-title>
            {{ fairTitle }}
            <styled-sub-title v-if="currentLocationLabel && currentBoothLabel">
              ({{ currentLocationLabel }} / {{ currentBoothLabel }})
            </styled-sub-title>
          </styled-title>

          <!-- step title -->
          <!-- more info toggle -->
          <styled-info-toggle v-if="infoText">
            <a href @click.prevent="toggleInfoArea">
              <styled-step-label>{{ stepLabel }}</styled-step-label>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                viewBox="0 0 60 60"
              >
                <g fill="none" fill-rule="evenodd">
                  <circle cx="30" cy="30" r="30" fill="#2E9699" />
                  <g transform="translate(23 12)">
                    <path stroke="#FFF" stroke-width="5" d="M0 17h8v17.5" />
                    <circle cx="7" cy="5" r="5" fill="#FFF" />
                    <path stroke="#FFF" stroke-width="5" d="M0 33h16" />
                  </g>
                </g>
              </svg>
            </a>
          </styled-info-toggle>
          <styled-step-label v-if="!infoText"
            >{{ stepLabel }}
          </styled-step-label>
        </styled-text-wrapper>

        <!-- back button -->
        <styled-button :href="backUrl" v-if="stepLabel">
          {{ buttonLabelTasks }}
        </styled-button>
        <styled-button :href="backUrl" v-else>
          {{ buttonLabelRegistration }}
        </styled-button>

        <!-- Back link mobile -->
        <styled-back-link :href="backUrl">
          <svg
            width="32px"
            height="32px"
            viewBox="0 0 40 40"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <!-- Generator: Sketch 57.1 (83088) - https://sketch.com -->
            <title>atom/icon/back_mobile/default</title>
            <desc>Created with Sketch.</desc>
            <g
              id="atom/icon/back_mobile/default"
              stroke="none"
              stroke-width="1"
              fill="none"
              fill-rule="evenodd"
            >
              <path
                d="M37,20.5 L7,20.5"
                id="Path-2"
                stroke="#4187BA"
                stroke-width="6"
              ></path>
              <polyline
                id="Path-4"
                stroke="#4187BA"
                stroke-width="6"
                transform="translate(14.000000, 20.500000) rotate(-270.000000) translate(-14.000000, -20.500000) "
                points="-1 13 14 28 29 13"
              ></polyline>
            </g>
          </svg>
          <svg
            style="transform: translateY(3px);"
            width="20px"
            height="20px"
            viewBox="0 0 40 40"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <!-- Generator: Sketch 57.1 (83088) - https://sketch.com -->
            <title>atom/icon/back_mobile/default</title>
            <desc>Created with Sketch.</desc>
            <g
              id="atom/icon/back_mobile/default"
              stroke="none"
              stroke-width="1"
              fill="none"
              fill-rule="evenodd"
            >
              <path
                d="M37,20.5 L7,20.5"
                id="Path-2"
                stroke="#FFFFFF"
                stroke-width="6"
              ></path>
              <polyline
                id="Path-4"
                stroke="#FFFFFF"
                stroke-width="6"
                transform="translate(14.000000, 20.500000) rotate(-270.000000) translate(-14.000000, -20.500000) "
                points="-1 13 14 28 29 13"
              ></polyline>
            </g>
          </svg>
        </styled-back-link>
      </styled-flex-wrapper>
    </styled-container>

    <styled-bottom-header>
      <styled-container :max-width="containerWidth">
        <!-- fair title -->
        <styled-title>
          {{ fairTitle }}
          <styled-sub-title v-if="currentLocationLabel && currentBoothLabel">
            ({{ currentLocationLabel }} / {{ currentBoothLabel }})
          </styled-sub-title>
        </styled-title>

        <!-- step title -->
        <!-- more info toggle -->
        <styled-info-toggle v-if="infoText">
          <a href @click.prevent="toggleInfoArea">
            <styled-step-label>{{ stepLabel }}</styled-step-label>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              viewBox="0 0 60 60"
            >
              <g fill="none" fill-rule="evenodd">
                <circle cx="30" cy="30" r="30" fill="#2E9699" />
                <g transform="translate(23 12)">
                  <path stroke="#FFF" stroke-width="5" d="M0 17h8v17.5" />
                  <circle cx="7" cy="5" r="5" fill="#FFF" />
                  <path stroke="#FFF" stroke-width="5" d="M0 33h16" />
                </g>
              </g>
            </svg>
          </a>
        </styled-info-toggle>
        <styled-step-label v-if="!infoText">{{ stepLabel }}</styled-step-label>
      </styled-container>
    </styled-bottom-header>

    <!-- info area -->
    <styled-info-area v-if="infoAreaIsOpen">
      <styled-container :max-width="containerWidth">
        <styled-closer>
          <a href @click.prevent="toggleInfoArea">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                fill="#4187BA"
                fill-rule="evenodd"
                d="M15.839 7l-1.86 3.223L12.234 7H8.116l3.808 6.5L8 20.272h4.254l1.736-3.235 1.786 3.235H20l-3.932-6.806L19.9 7z"
              />
            </svg>
            {{ closeLabel }}
          </a>
        </styled-closer>
        <styled-flex-wrapper-bottom>
          <styled-info-icon-bottom>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="60"
              height="60"
              viewBox="0 0 60 60"
            >
              <g fill="none" fill-rule="evenodd">
                <circle cx="30" cy="30" r="30" fill="#2E9699" />
                <g transform="translate(23 12)">
                  <path stroke="#FFF" stroke-width="5" d="M0 17h8v17.5" />
                  <circle cx="7" cy="5" r="5" fill="#FFF" />
                  <path stroke="#FFF" stroke-width="5" d="M0 33h16" />
                </g>
                P
              </g>
            </svg>
          </styled-info-icon-bottom>
          <styled-paragraph v-html="infoText" />
        </styled-flex-wrapper-bottom>
      </styled-container>
    </styled-info-area>
  </styled-wrapper>
</template>

<script>
import styled from "vue-styled-components";
import axios from "axios";

const containerProps = { maxWidth: String };

const minWidth = "1024px";
const styledWrapper = styled.div`
  background-color: #f7f6f3;
  box-sizing: inherit;
`;
const styledInfoIconBottom = styled.div`
  display: none;
  > svg {
    width: 60px;
    height: 60px;
  }
  margin-right: 42px;

  @media (min-width: 1024px) {
    display: block;
  }
`;
const styledContainer = styled("div", containerProps)`
  max-width: ${props => props.maxWidth};
  padding: 24px 20px 26px 20px;
  margin: 0 auto;
  position: relative;
`;
const styledFlexWrapper = styled.div`
  display: flex;
  position: relative;
  justify-content: left;
`;
const styledFlexWrapperBottom = styled.div`
  display: flex;
  position: relative;
`;
const styledTextWrapper = styled.div`
  display: none;
  padding: 0 3rem;

  @media (min-width: ${minWidth}) {
    display: table;
  }
`;
const styledTitle = styled.h2`
  font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
  font-size: 21px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.43;
  letter-spacing: 0.6px;
  color: #333333;
  margin: -6px 0 0 0;
`;
const styledSubTitle = styled.h3`
  font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  font-stretch: normal;
  line-height: 1;
  letter-spacing: 0.6px;
  color: #333;
  margin: 0;
  display: inline-block;
  padding-left: 12px;
`;
const styledStepLabel = styled.span`
  font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
  font-size: 21px;
  font-weight: 400;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.43;
  letter-spacing: 0.6px;
  vertical-align: top;
  margin-top: 12px;
  color: #333333;
`;
const styledButton = styled.a`
  font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
  display: none;
  border: solid 0px #a5914b;
  border-radius: 10px;
  font-size: 16px;
  text-transform: uppercase;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 0.6px;
  color: white !important;
  background-color: #a5914b;
  padding: 0.65em 2vw;
  cursor: pointer;
  margin-top: -6px;
  text-decoration: none;
  transition: all 0.2s ease-in-out;

  svg {
    &:last-of-type {
      display: none;
    }
  }

  &:hover {
    border: solid 0px #a5914b;
    border-radius: 10px;
    font-size: 16px;
    text-transform: uppercase;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: 0.6px;
    color: white !important;
    background-color: #a5914b;
    padding: 0.65em 2vw;
    cursor: pointer;
    margin-top: -6px;
    text-decoration: none;
    transition: all 0.2s ease-in-out;
    transform: scale(1.1);

    svg {
      &:first-of-type {
        display: none;
      }
      &:last-of-type {
        display: initial;
      }
    }
  }

  position: absolute;
  right: 0;

  @media (min-width: ${minWidth}) {
    display: block;
  }
`;
const styledInfoArea = styled.div`
  display: block;
  border-top: 1px solid #979797;
  background-color: #f7f6f3;
  box-sizing: inherit;
  padding-bottom: 28px;
`;
const styledBackLink = styled.a`
  display: block;
  width: 22px;
  height: 41px;
  opacity: 0.6;
  margin-left: 0;
  position: absolute;
  right: 0;

  @media (min-width: ${minWidth}) {
    display: none;
  }
`;
const styledParagraph = styled.div`
  font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
  font-size: 21px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  padding: 0;

  p {
    margin: 0 0 28px 0;
  }
`;
const styledCloser = styled.div`
  display: block;
  text-align: right;
  font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
  font-size: 21px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.43rem;
  letter-spacing: 0.6px;
  margin: 28px 0 14px 0;
  > a {
    display: inline-block;
    text-decoration: none;
    color: #4187ba;
    &:hover {
      text-decoration: underline;
    }

    > svg {
      height: 24px;
      margin-bottom: 6px;
    }
  }
`;
const styledInfoToggle = styled.span`
  font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
  font-size: 21px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.43;
  letter-spacing: 0.6px;

  > a {
    position: relative;
    right: 0px;
    text-decoration: none;
    color: #4187ba;
    span {
      //display: none;
      @media (min-width: ${minWidth}) {
        display: inline-block;
      }
    }
    svg {
      width: 21px;
      height: 21px;
      position: absolute;
      transform: translateY(7px) translateX(10px);
      margin-top: -4px;
    }

    &:hover {
      text-decoration: underline;
    }

    @media (min-width: ${minWidth}) {
      position: relative;
      right: unset;

      svg {
        transform: translateY(18px) translateX(10px) !important;
      }
    }
  }
`;
const styledLogoWrapper = styled.div`
  display: block;
  width: 166px;
  height: 41px;
  margin-left: -3.3333%;

  > img {
    max-width: 166px;
  }

  @media (min-width: ${minWidth}) {
    margin-left: unset;
  }
`;
const styledBottomHeader = styled("div", containerProps)`
  display: block;
  padding: 12px 0 0 0;
  border-top: 1px solid darkgrey;

  @media (min-width: ${minWidth}) {
    display: none;
  }
`;

export default {
  props: {
    containerWidth: {
      type: String,
      default: "1280px"
    },
    boothLabel: {
      type: String,
      default: null
    },
    locationLabel: {
      type: String,
      default: null
    },
    fairId: {
      type: String,
      default: null
    },
    serviceGroup: {
      type: String,
      default: null
    },
    regiNr: {
      type: String,
      default: null
    },
    language: {
      type: String,
      default: "de"
    },
    baseUrl: {
      type: String,
      default: "https://bex-dev-oneshop.herokuapp.com"
    }
  },
  data() {
    return {
      backUrl: null,
      infoAreaIsOpen: false,
      currentVersion: "1.0.20",

      currentFairId: null,
      currentServiceGroup: null,
      currentRegiNr: null,
      currentLocationLabel: null,
      currentBoothLabel: null,
      currentLanguage: null,

      fairTitle: null,
      stepLabel: null,
      infoText: null,
      moreInfoLabel: null,
      buttonLabelTasks: null,
      buttonLabelRegistration: null,
      closeLabel: null,
      i18n: {
        de: {
          moreInfoLabel: "Mehr",
          buttonLabelTasks: "Zurück zu Aufgaben",
          buttonLabelRegistration: "Zurück zur Anmeldung",
          closeLabel: "Schliessen"
        },
        fr: {
          moreInfoLabel: "plus",
          buttonLabelTasks: "Retour aux tâches",
          buttonLabelRegistration: "Retour à l'inscription",
          closeLabel: "fermé"
        },
        en: {
          moreInfoLabel: "more",
          buttonLabelTasks: "Back to tasks",
          buttonLabelRegistration: "Back to registration",
          closeLabel: "close"
        }
      }
    };
  },
  components: {
    styledWrapper,
    styledContainer,
    styledTextWrapper,
    styledTitle,
    styledSubTitle,
    styledStepLabel,
    styledInfoToggle,
    styledButton,
    styledInfoArea,
    styledParagraph,
    styledInfoIconBottom,
    styledFlexWrapper,
    styledFlexWrapperBottom,
    styledCloser,
    styledBackLink,
    styledLogoWrapper,
    styledBottomHeader
  },
  methods: {
    toggleInfoArea() {
      this.infoAreaIsOpen = !this.infoAreaIsOpen;
    },
    getDetailData() {
      console.log(this.currentFairId, this.currentServiceGroup);

      if (this.currentFairId) {
        if (!this.currentServiceGroup) {
          this.serviceGroup = "new";
        }
        axios
          .get(
            this.baseUrl +
              "/fairHeaderInfoByStep?code=" +
              this.currentFairId +
              "&serviceGroup=" +
              this.currentServiceGroup
          )
          .then(response => {
            switch (this.language) {
              case "en":
                this.fairTitle = response.data[0].displayNameEn;
                this.stepLabel = response.data[0].tasks.taskTitleEn;
                this.infoText = response.data[0].tasks.headerTextEn;
                break;
              case "fr":
                this.fairTitle = response.data[0].displayNameFr;
                this.stepLabel = response.data[0].tasks.taskTitleFr;
                this.infoText = response.data[0].tasks.headerTextFr;
                break;
              default:
                this.fairTitle = response.data[0].displayNameDe;
                this.stepLabel = response.data[0].tasks.taskTitleDe;
                this.infoText = response.data[0].tasks.headerTextDe;
            }
          })
          .catch(error => console.log(error));
      }
    }
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);

    //  Get params from url if not specified.
    if (!this.language) {
      if (urlParams.has("language")) {
        this.currentLanguage = urlParams.get("language");
        localStorage.setItem("language", this.currentLanguage);
      } else {
        if (localStorage.getItem("language")) {
          this.currentLanguage = localStorage.getItem("language");
        }
      }
    } else {
      this.currentLanguage = this.language;
      localStorage.setItem("language", this.currentLanguage);
    }

    if (!this.boothLabel) {
      if (urlParams.has("booth-label")) {
        this.currentBoothLabel = urlParams.get("booth-label");
        localStorage.setItem("boothLabel", this.currentBoothLabel);
      } else {
        if (localStorage.getItem("boothLabel")) {
          this.currentBoothLabel = localStorage.getItem("boothLabel");
        }
      }
    } else {
      this.currentBoothLabel = this.boothLabel;
      localStorage.setItem("boothLabel", this.currentBoothLabel);
    }

    if (!this.locationLabel) {
      if (urlParams.has("location-label")) {
        this.currentLocationLabel = urlParams.get("location-label");
        localStorage.setItem("locationLabel", this.currentLocationLabel);
      } else {
        if (localStorage.getItem("locationLabel")) {
          this.currentLocationLabel = localStorage.getItem("locationLabel");
        }
      }
    } else {
      this.currentLocationLabel = this.locationLabel;
      localStorage.setItem("locationLabel", this.currentLocationLabel);
    }

    if (!this.fairId) {
      if (urlParams.has("fair-id")) {
        this.currentFairId = urlParams.get("fair-id");
        localStorage.setItem("fairId", this.currentFairId);
      } else {
        if (localStorage.getItem("fairId")) {
          this.currentFairId = localStorage.getItem("fairId");
        }
      }
    } else {
      this.currentFairId = this.fairId;
      localStorage.setItem("fairId", this.currentFairId);
    }

    if (!this.serviceGroup) {
      if (urlParams.has("service-group")) {
        this.currentServiceGroup = urlParams.get("service-group");
        localStorage.setItem("serviceGroup", this.currentServiceGroup);
      } else {
        //if (localStorage.getItem("serviceGroup")) {
        //this.currentServiceGroup = localStorage.getItem("serviceGroup");
        this.currentServiceGroup = null;
        //}
      }
    } else {
      this.currentServiceGroup = this.serviceGroup;
      localStorage.setItem("serviceGroup", this.currentServiceGroup);
    }

    if (!this.regiNr) {
      if (urlParams.has("regi-nr")) {
        this.currentRegiNr = urlParams.get("regi-nr");
        localStorage.setItem("regiNr", this.currentRegiNr);
      } else {
        //if (localStorage.getItem("regiNr")) {
        // this.currentRegiNr = localStorage.getItem("regiNr");
        this.currentRegiNr = "new";
        //}
      }
    } else {
      this.currentRegiNr = this.regiNr;
      localStorage.setItem("regiNr", this.currentRegiNr);
    }

    // Get step tracking info for current regi-nr.
    if (this.currentRegiNr) {
      this.backUrl = `${this.baseUrl}/fair/${this.currentFairId}/${this.currentRegiNr}`;

      // Get  info for booth from OneShop api.
      axios
        .get(this.baseUrl + "/stepTracker/" + this.currentRegiNr.toString())
        .then(response => {
          if (response.data[0]) {
            this.currentBoothLabel = response.data[0].boothLabel;
            this.currentLocationLabel = response.data[0].boothArea;
            this.currentFairId = response.data[0].fairId;
            this.currentServiceGroup = response.data[0].taskId;
          }

          // Get  fair info from OneShop api.
          this.getDetailData();

          this.moreInfoLabel = this.i18n[this.language].moreInfoLabel;
          this.buttonLabelTasks = this.i18n[this.language].buttonLabelTasks;
          this.buttonLabelRegistration = this.i18n[this.language].buttonLabelRegistration;
          this.closeLabel = this.i18n[this.language].closeLabel;
        })
        .catch(error => console.log(error));
    } else {
      this.backUrl = `${this.baseUrl}/fair/${this.currentFairId}`;
    }
  },
  name: "BexHeader"
};
</script>
